import { getFetch } from '@/plugins/http';
import { postFetch } from '../../plugins/http';

const baseHost = '//nuc.zhihuishu.com/hike-boot'

export default {
  /**
   * 首页课程列表接口
   */
  getHomeCourseList(params) {
    return getFetch(`${baseHost}/common/api/34/course_recommend`, { is_recommend: 1, "_order.direction": 0, '_order.by': 'recommend_sort', "_pageable.size": 10, '_pageable.page': 0, ...params })
  },
  /**
   * 首页课程列表接口
   */
  getHomeBannerList(params) {
    return getFetch(`${baseHost}/common/api/33/banner`, params)
  },

  /**
   * 首页教师列表
   */
  getHomeTeacherList(params) {
    return getFetch(`${baseHost}/common/api/33/p_recommend_teacher`, params)
  },
  /**
   * 课程列表（分类）
   */
  getCourseList(params) {
    return getFetch(`${baseHost}/common/api/34/course_choose`, params)
  },
  /**
   * 课程列表（分类）-排序
   */
  getSortCourseList(params) {
    return getFetch(`${baseHost}/common/api/34/p_course_sort`, params)
  },

  /**
   * 课程总览列表
   */
  getAllCourseList(params) {
    return getFetch(`${baseHost}/common/api/34/course_choose`, params)
  },
  /**
   * 课程列表排序
   * @returns 
   */
  getSortAllCourseList(params) {
    return getFetch(`${baseHost}/common/api/34/p_all_course_sort`, params)
  },

  /**
   * 精品课程 一流课程分类
   * @returns 
   */
  getCourseClassify(type) {
    return getFetch(`${baseHost}/common/api/33/course_classify`)
  },
  /**
   * 精品课程 一流课程分类
   * @returns 
   */
  getResluts(courseType) {
    return getFetch(`${baseHost}/common/api/33/p_course_results`, { courseType })
  },

  /**
   * 课程学院分类、课程成果
   */
  getCollegeCourseKinds(params) {
    return getFetch(`${baseHost}/common/api/36/course_drop_down`, params)
  },
  /**
   * 课程学科
   */
  getCourseSubject(params) {
    return getFetch(`${baseHost}/common/api/37/subject`, params)
  },
  /**
   * 教师归属学院、荣誉称号
   */
  getTeacherCollegeAndTitle(params) {
    return getFetch(`${baseHost}/common/api/36/teacher_drop_down`, params)
  },
  /**
   * 教师列表
   */
  getTeacherList(params) {
    return getFetch(`${baseHost}/common/api/34/teacher`, params)
  },
  /**
   * 教师详情
   */
  getTeacherDetail(teacherId) {
    return getFetch(`${baseHost}/common/api/32/teacher`, teacherId)
  },
  /**
   * 教师详情页推荐课程
   */
  getTeacherRecommendCourse(params) {
    return getFetch(`${baseHost}/common/api/34/course`, params)
  },
  /*
   * 全局搜索
   */
  globalSearch(params) {
    return getFetch(`${baseHost}/common/api/36/global_search`, params)
  },
  /*
   * 通知公告列表
   */
  getNewsList(params) {
    return getFetch(`${baseHost}/common/api/34/page_news`, params)
  },
  /*
   * 通知公告列表
   */
  getNewsTypeList(params) {
    return getFetch(`${baseHost}/common/api/33/news_type`, { menuType: 2 })
  },

  /*
   * 新闻详情
   */
  getNewsDetail(id) {
    return getFetch(`${baseHost}/common/api/35/news`, id)
  },

  viewNews(id) {
    return postFetch(`${baseHost}/common/news/accessRecords?id=${id}`)
  },
  /*
   * 获取学期列表
   */
  getTermList(params) {
    return getFetch(`${baseHost}/common/api/33/school_term`, params)
  },
  // 获取教师学期列表
  getTeacherTermList(params) {
    return getFetch(`${baseHost}/common/api/33/p_teacher_school_term`, params)
  }
}